/**
 * SearchSpring configuration utilities
 * Provides site ID and domain configuration for SearchSpring API requests
 */

import { globalState } from '@/components/helpers/utils'

/**
 * Returns the bgfilter.tags value for the current market's in-stock tag,
 * e.g. "Flow:InStock:[market-handle]". Returns null if no market is set.
 */
export function getMarketInStockTag() {
  const market = window.globals?.localization?.market
  if (!market) {
    console.warn('[SearchSpring] getMarketInStockTag: no market handle found on window.globals.localization.market — bgfilter.tags will not be applied')
  }
  return market ? `Flow:InStock:${market}` : null
}

export function getSearchSpringSiteID(category = 'products') {
  return globalState.siteIds[category]
}

export function getSearchSpringDomain(category) {
  switch (category) {
    case 'collections':
      return window.location.host + '/collections?view=ss-feed'
    case 'pages':
      return window.location.host + '/pages/faqs?view=ss-feed'
    case 'blogs':
      return window.location.host + '/blogs/fashion?view=ss-feed'
    case 'products':
    default:
      return window.location.href
  }
}
